const projectManage = [{
  desc: '查询项目数量统计',
  options: {
    url: '/projectManage/queryStatistic'
  }
}, {
  desc: '查询项目列表',
  options: {
    url: '/projectManage/queryList'
  }
}, {
  desc: '关闭项目',
  options: {
    url: '/projectManage/closeProject',
    method: 'post'
  }
}, {
  desc: '新增、编辑项目',
  options: {
    url: '/projectManage/addOrUpdate',
    method: 'post'
  }
}]
export default projectManage



// WEBPACK FOOTER //
// ./src/api/projectManage.js